import instance from "../xhrService";
import db from '../../db/db';

export const inspectionQuestionApi = {
  show: async (id: number) => {
    const offline = navigator.onLine ? false : true;

    if (!offline) {
      return instance
        .get(`/api/inspections/${id}/questions`)
        .then((response) => response.data);
    } else {
      return await db.questions.get(Number(id)).catch((e: any) => {
        console.log('error', e);
        throw e;
      });
    }
  },
  getDefaultAnswers: async (id: number) => {
    return instance
      .get(`/api/inspectionsQuestion/getDefaultQuestions/${id}`)
      .then((response) => response.data);
  },
};
